import { useMemo } from 'react';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Banners } from '@sorare/core/src/components/layout/Banners';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { useTour } from '@sorare/core/src/hooks/useTour';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/baseball';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { primaryMarketFilters } from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import { BaseballCardSearch } from 'components/searchCards/BaseballCardSearch';

const PrimaryMarket = () => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  const {
    flags: { useMlbSeasonAverageScore = true },
  } = useFeatureFlags();

  useTitleAndDescription(
    metadatas.newSignings.title,
    metadatas.newSignings.description
  );
  const filtersTour = useTour(LIFECYCLE.newSignings, 'filters');
  const cardsTour = useTour(LIFECYCLE.newSignings, 'cards');
  const filters = useDefaultFilters({
    auction: true,
  });

  const cardSorts = createCardSorts({
    indexPrefix: 'Cards On Sale',
    withHighestAverageScore: true,
  });
  const defaultSort = 'Cards On Sale Ending Soon';

  const cardsFilter = useMemo(
    () => primaryMarketFilters(useMlbSeasonAverageScore),
    [useMlbSeasonAverageScore]
  );

  return (
    <>
      {!!(!isIosApp || isMarketAuthorizedIosApp) && <Banners />}
      <MarketRoot>
        <Vertical gap={2}>
          <BaseballCardSearch
            sorts={cardSorts}
            defaultSort={defaultSort}
            cardFilters={cardsFilter}
            defaultFilters={filters}
            analyticsTags={['NewSignings', 'Baseball']}
            onlyPrimary
            removeFinishedAuctions
            filtersTour={filtersTour}
            cardsTour={cardsTour}
            hideSorareUser
          />
        </Vertical>
      </MarketRoot>
      {!!isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};

export default PrimaryMarket;
